"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModuleTypes = void 0;
var ModuleTypes;
(function (ModuleTypes) {
    ModuleTypes["Standard"] = "standard";
    ModuleTypes["Free"] = "free";
    ModuleTypes["Extra"] = "extra";
    ModuleTypes["Paid"] = "paid";
})(ModuleTypes || (exports.ModuleTypes = ModuleTypes = {}));
